angular.module('zc.master')
  .component('zcMasterHomeAlert', {
    templateUrl: '/templates/master/components/master_home_alert/master_home_alert.html',
    bindings: {
      projects: '<',
      filters: '<'
    },
    controller: zcMasterHomeAlert,
  });


zcMasterHomeAlert.$inject = ['Devise', 'SearchFilter', 'MasterProject', '$scope'];
function zcMasterHomeAlert(Devise, SearchFilter, MasterProject, $scope) {
  const vm = this;

  vm.searchTerm = '';
  vm.filterProjects = filterProjects;
  vm.toggleExpandedAlert = toggleExpandedAlert;
  vm.toggleAllAlert = toggleAllAlert;
  vm.star = star;
  vm.unstar = unstar;

  function filterProjects(project) {
    if(!vm.filters.all_alert && !project.starred) return false;
    if(vm.searchTerm === '') return true;
    if(project.title.indexOf(vm.searchTerm) >= 0) return true;
    if(project.apikey.indexOf(vm.searchTerm) >= 0) return true;
    return false;
  }

  function toggleExpandedAlert() {
    vm.filters.expanded_alert = !vm.filters.expanded_alert;
    _.each(vm.projects, project => {
      project.expanded_alert = vm.filters.expanded_alert;
    });
    SearchFilter.updateComponentDefaults('home');
  }

  function toggleAllAlert() {
    vm.filters.all_alert = !vm.filters.all_alert;
    SearchFilter.updateComponentDefaults('home');
  }

  function star(project) {
    MasterProject.assign({projectId: project.id}, {userId: Devise.currentUser.id}).then(res => {
      if(res.data.success) {
        _.each(vm.projects, p => {
          if(project.apikey === p.apikey) {
            p.starred = true;
          }
        });

        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = true;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }

  function unstar(project) {
    MasterProject.unassign({projectId: project.id}, {userId: Devise.currentUser.id}).then(res => {
      if(res.data.success) {
        _.each(vm.projects, p => {
          if(project.apikey === p.apikey) {
            p.starred = false;
          }
        });

        // In order for the campaign-filter-view to work properly we need propagate this change
        // to the parent scope as well (unless reloading the entire page).
        $scope.$parent.$ctrl.starredApikeyMap[project.apikey] = false;
        $scope.$parent.$ctrl.updateReports();
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/master_admin_modules/master/components/master_home_alert/master_home_alert.js